import React, { useState } from 'react';
import Notes from 'src/common/components/notes';
import { sizes } from 'src/styles/Media.styled';
import { TextBold, OrderDetailTabBodyContainer } from './index.styled';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import { useSelector, useDispatch } from 'react-redux';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import UnsavedChanges from 'src/pages/scheduleSurgery/components/surgery/notifications/UnsavedChanges';
import {
    setUnsavedChange,
    setCommonCancel,
    setTemplateNoteAccount,
    setTemplateNoteChangeAccount,
} from 'src/pages/more/redux/actions/index.js';
import {
    FIA_USER_ROLE,
    FIM_USER_ROLE,
    ITA_USER_ROLE,
} from 'src/constants/appConstants';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const AccountNotes = ({ onSave, employeeRole, setTemplateNotesPopup, isFromNotes, selectedTabIdAccount }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [textAreaCharLimit] = useState(4000);
    const [saved] = useState(false);
    const [isCancel, setisCancel] = useState(false);
    useEffectWithErrorLogging(() => {
        dispatch(setCommonCancel(false));
        dispatch(setUnsavedChange(false));
        //document.getElementById("NotesID").placeholder='Enter Account Note here.' + '\n' + 'Do not use this field for Patient Data or Employee personal details.';
    }, []);
    const accountNotes = useSelector(
        (state) =>
            state.accountReducer.accountDetails.noteDetails &&
            state.accountReducer.accountDetails.noteDetails.notes
    );
    const templateNote = useSelector(
        (state) => state.accountReducer.templateNoteAccount
    );
    const templateNoteChange = useSelector(
        (state) => state.accountReducer.templateNoteChangeAccount
    );
    useEffectWithErrorLogging(() => {
        if (accountNotes && !templateNoteChange) {
            dispatch(setTemplateNoteAccount(accountNotes));
        }
    }, [accountNotes]);
    const handleNote = (note) => {
        dispatch(setCommonCancel(false));
        // dispatch(setUnsavedChange(true));
        if (templateNote !== note) {
            dispatch(setTemplateNoteChangeAccount(true));
            dispatch(setUnsavedChange(true));
        }
        const lengthOfNote = note.length;
        if (lengthOfNote <= 4000) {
            dispatch(setTemplateNoteAccount(note));
        } else {
            const sliceLastIdx = 4000 - lengthOfNote;
            dispatch(setTemplateNoteAccount(note.slice(0, sliceLastIdx)));
            setTemplateNotesPopup(true);
        }
    };

    const closekeyBoard = () => {
        document.activeElement.blur();
    };

    const handlePopupOnKeyPress = () => {
        if (templateNote.length >= 4000) {
            setTemplateNotesPopup(true);
            closekeyBoard();
        }
    };

    const onCancel = () => {
        if (templateNoteChange) {
            setisCancel(true);
        }
        // if (templateNote.length > 0) setisCancel(true);
        // else onClose();
    };
    const handleDiscardChanges = () => {
        accountNotes
            ? dispatch(setTemplateNoteAccount(accountNotes))
            : dispatch(setTemplateNoteAccount(''));
        setisCancel(false);
        dispatch(setTemplateNoteChangeAccount(false));
        dispatch(setUnsavedChange(false));
    };
    const handleSaveAndExit = () => {
        setisCancel(false);
    };
    const fromSettingsClose = () => {
        setisCancel(false);
    };
    const placeholderText =
        t('more.common.enteraccount');
        
    return (
        <>
            <OrderDetailTabBodyContainer>
                <Notes
                    height={'unset'}
                    contentBodyBackground={'none'}
                    backGround={'none'}
                    borderRadius={'0'}
                    border={'none'}
                    margin={'0'}
                    boxShadow={'none'}
                    contentBodyMargin="0"
                    cardFooterMargin="5px 0 0 5px"
                    note={templateNote}
                    placeholder={placeholderText}
                    updateNotes={handleNote}
                    helperText={`${templateNote !== undefined
                            ? 4000 - templateNote?.length < 0
                                ? 0
                                : 4000 - templateNote?.length
                            : 4000
                        } ${t('consignmentBilling.priceOverride.charactersRemainingLabel')}`}
                    fontSize="14px"
                    rows="8"
                    maxLength={textAreaCharLimit}
                    onKeyPress={handlePopupOnKeyPress}
                    textAreaDisabled={
                        saved ||
                        employeeRole == FIM_USER_ROLE ||
                        employeeRole == FIA_USER_ROLE ||
                        employeeRole == ITA_USER_ROLE
                    }
                textAreaId={"account-notes-textarea"}
                />
                {/* {templateNotesPopup ? (
                    <AddedMoreThanTenItems
                        title="Form doesn't allow characters past 4000"
                        onClose={() => {
                            setTemplateNotesPopup(false);
                        }}
                        opacity={'1'}
                        zIndex={999999999}
                        background={'#000000cc 0% 0% no-repeat padding-box'}
                    />
                ) : null} */}
            </OrderDetailTabBodyContainer>
            {employeeRole !== FIM_USER_ROLE &&
                employeeRole !== ITA_USER_ROLE &&
                employeeRole !== FIA_USER_ROLE && (
                    <BottomNavigation
                        isIPadPotrait={true}
                        iPadPortraitFooterPosition={'fixed'}
                        opacity={'1'}
                        border={'1px solid #1010EB'}
                        // borderRadius={'25px'}
                        position={'fixed'}
                        padding={'11px 25px 11px 25px !important'}
                        justifyContent={'flex-end'}
                        moblieJustifyContent={'center'}
                        bottom={'0'}
                        left={'0'}
                        right={'0'}
                        selectedTabIdAccount={selectedTabIdAccount}
                    >
                        <Button
                            id={'accounts-accountdetails-cancelButton'}
                            show={true}
                            // secondary={true}
                            variant={ButtonStyles.secondary}
                            border={'1px solid #140F4B'}
                            top={'659px'}
                            color={'#140F4B'}
                            left={'670px'}
                            width={'131px'}
                            mobileWidth={'160px'}
                            height={'38px'}
                            margin={
                                window.innerWidth <= sizes.mobileDevice
                                    ? '0px 6px 0px 0px'
                                    : '0px 20px 0px 0px'
                            }
                            clicked={onCancel}
                        >
                            <TextBold color={'#140F4B'}>{t('more.common.cancel')}</TextBold>
                        </Button>
                        <Button
                            id={'accounts-accountdetails-saveButton'}
                            show={true}
                            // primary={
                            //     templateNoteChange && !saved ? true : false
                            // }
                            disabled={!templateNoteChange || saved}
                            variant={
                                templateNoteChange && !saved
                                    ? ButtonStyles.primary
                                    : ButtonStyles.disabled
                            }
                            top={'659px'}
                            left={'670px'}
                            width={'131px'}
                            mobileWidth={'160px'}
                            height={'38px'}
                            clicked={templateNoteChange && !saved ? onSave : null}
                        >
                            <TextBold color={'#FFFFFF'}>{t('more.common.save')}</TextBold>
                        </Button>
                    </BottomNavigation>
                )}
            {isCancel ? (
                <UnsavedChanges
                    onDiscard={handleDiscardChanges}
                    onClose={handleSaveAndExit}
                    continueText={t('more.common.conedit')}
                    fromSettingsClose={fromSettingsClose}
                    fromMore={true}
                />
            ) : null}
        </>
    );
};
export default AccountNotes;
